export default __webpack_public_path__ + "34b27a93a656e2e35eb095af1f4d6bb0.png";